<template>
  <div>
    <ul class="main-category type02">
      <li :class="{active: fetchedSurveyAnswerYn === YN.N}"
          @click="changeSurveyAnswerYn(YN.N)">
        <span>진행중인 설문조사</span>
      </li>
      <li :class="{active: fetchedSurveyAnswerYn === YN.Y}"
          @click="changeSurveyAnswerYn(YN.Y)">
        <span>나의 설문조사</span>
      </li>
    </ul>
  </div>
</template>

<script>
import {YN} from "../../AppConstants";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  computed: {
    ...mapGetters(['fetchedSurveyAnswerYn']),
    YN() {
      return YN
    },
  },
  methods: {
    ...mapMutations(['SET_SURVEY_ANSWER_YN']),
    ...mapActions(['FETCH_SURVEYS']),
    changeSurveyAnswerYn(answerYn) {
      // 설문조사 탭 변경
      this.SET_SURVEY_ANSWER_YN(answerYn);

      // 파라미터 설정
      const params = {
        answerYn: this.fetchedSurveyAnswerYn === YN.N ? YN.N : YN.Y
      }

      // 설문조사 목록 조회
      this.showLoading(true);
      this.FETCH_SURVEYS(params)
        .then(response => {
          if (response.code !== '0000') {
            this.showAlert(response.message);
          }
        })
        .catch(error => this.showAlert("설문조사 리스트 조회에 실패했습니다."))
        .finally(() => this.showLoading(false));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/common/SurveyTab.vue